import React from "react";
import { injectIntl } from "react-intl";
import Modal from "../../../Base/Modal/Modal";

import "./EditAttemptModal.scss";

const EditAttemptModal = (props) => {
  const {
    entity,
    personId,
    isScored,
    hasChanges,
    canEditOutcome,
    onPersonChange,
    onOutcomeChange,
    onCancel,
    onSave,
    intl,
  } = props;
  const { formatMessage } = intl;

  return (
    <Modal
      className="shootout-edit-modal"
      title={formatMessage({
        id: "shootOut.editAttempt.title",
        defaultMessage: "Edit Shootout Attempt",
      })}
      onClose={onCancel}
    >
      <div className="shootout-edit-content">
        <div className="shootout-edit-field">
          <label htmlFor="shootout-edit-player">
            {formatMessage({
              id: "player",
              defaultMessage: "Player",
            })}
          </label>
          <select
            id="shootout-edit-player"
            value={personId}
            onChange={(event) => onPersonChange(event.target.value)}
          >
            {entity.persons.map((person) => (
              <option key={person.personId} value={person.personId}>
                #{person.bib} - {person.name}
              </option>
            ))}
          </select>
        </div>
        <fieldset className="shootout-edit-field">
          <legend>
            {formatMessage({
              id: "outcome",
              defaultMessage: "Outcome",
            })}
          </legend>
          <div className="shootout-edit-outcomes">
            <button
              className={`shootout-edit-outcome missed ${!isScored ? "selected" : ""}`}
              type="button"
              aria-pressed={!isScored}
              disabled={!canEditOutcome}
              onClick={() => onOutcomeChange(false)}
            >
              {formatMessage({
                id: "missed",
                defaultMessage: "Missed",
              })}
            </button>
            <button
              className={`shootout-edit-outcome scored ${isScored ? "selected" : ""}`}
              type="button"
              aria-pressed={isScored}
              disabled={!canEditOutcome}
              onClick={() => onOutcomeChange(true)}
            >
              {formatMessage({
                id: "scored",
                defaultMessage: "Scored",
              })}
            </button>
          </div>
        </fieldset>
        <div className="shootout-edit-actions">
          <button type="button" className="shootout-edit-cancel" onClick={onCancel}>
            {formatMessage({ id: "cancel", defaultMessage: "Cancel" })}
          </button>
          <button type="button" className="shootout-edit-save" disabled={!hasChanges} onClick={onSave}>
            {formatMessage({
              id: "save",
              defaultMessage: "Save",
            })}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default injectIntl(EditAttemptModal);
